import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { CommonState, ICommonState } from './common-states.store';

import { CommonServices } from '../../services/index';
import actions from './common-actions.store';
import getters from './common-getters.store';
import mutations from './common-mutations.store';

export class CommonModule<RootState> implements Module<ICommonState, RootState>{
  namespaced: boolean;
  state: ICommonState;
  getters: GetterTree<ICommonState, RootState>;
  actions: ActionTree<ICommonState, RootState>;
  mutations: MutationTree<ICommonState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new CommonState({ service: new CommonServices, isHorizontalPage: false })
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}


